var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtriasError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 150",
    style: {
      enableBackground: "new 0 0 1440 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AF1F22;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#AF1F22;stroke-width:23;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#E4B4B5;stroke-width:4;stroke-miterlimit:10;}\n\t.st5{fill:#E4B4B5;}\n\t.st6{fill:#CA6A6C;}\n\t.st7{fill:none;stroke:#AF1F22;stroke-width:7.5837;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#AF1F22;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#AF1F22;stroke-width:7.5837;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#AF1F22;stroke-width:8;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cables"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1440,5.91c-62.27-9.06-130.96-7.36-215.68,9.58c-45.63,9.52-89.51,20.62-131.96,32.33 c-66.55,18.35-129.42,35.69-197.15,43.42c-37.13,3.84-71.12,3.36-103.92-1.46l-3.34,22.76c19.35,2.84,39.06,4.26,59.48,4.26 c16.23,0,32.91-0.9,50.21-2.69l0.12-0.01c69.53-7.94,133.25-25.51,200.71-44.11c42.1-11.61,85.62-22.61,130.45-31.96 c83.49-16.7,150.62-18.15,211.07-8.85V5.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1440,14c-61.64-9.14-129.79-7.53-214.04,9.32c-45.38,9.47-89.14,20.54-131.46,32.21 c-66.88,18.44-130.06,35.86-198.39,43.66c-37.82,3.91-72.48,3.43-105.97-1.5l-1.02,6.93c18.96,2.79,38.28,4.18,58.31,4.18 c15.96,0,32.38-0.88,49.43-2.65c68.91-7.87,132.34-25.36,199.49-43.87c42.22-11.64,85.87-22.68,131-32.1 c83.88-16.78,151.55-18.31,212.64-9.1V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.54,61.77l-0.11,0.05c-32.87,14.26-65.96,31.01-97.97,47.2C21.82,114.41,10.88,119.94,0,125.36v25.67 c0.42-0.21,0.85-0.41,1.27-0.62l3.32-1.64c12.8-6.34,25.74-12.88,38.25-19.22c31.69-16.03,64.45-32.61,96.68-46.6 c50.06-21.07,108.66-27.7,174.16-19.72l2.78-22.83C246.91,31.92,184.35,39.11,130.54,61.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.61,69.16c-32.65,14.17-65.64,30.86-97.54,47c-11.81,5.98-24,12.14-36.07,18.13v7.82l1.04-0.51 c12.77-6.32,25.69-12.86,38.19-19.18c31.81-16.1,64.7-32.74,97.13-46.81c51.38-21.63,111.36-28.47,178.28-20.31l0.85-6.95 C247.34,40.03,186.16,47.03,133.61,69.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.39,90.09C86,94.58,77,99.58,68.41,103.75c-2.31,1.17-4.62,2.35-6.91,3.53c-2.29,1.18-4.57,2.36-6.84,3.53 C36.81,120.03,18.37,129.55,0,138.66v4.47c18.99-9.39,38.05-19.24,56.5-28.76c2.27-1.17,4.55-2.35,6.83-3.53 c2.29-1.18,4.59-2.36,6.9-3.53C99,92.58,128,78.58,158.64,68.76c3.51-1.05,7.03-2.04,10.58-2.98 c46.08-12.25,95.36-15.7,145.62-9.97l0.45-3.97c-50.77-5.79-100.56-2.3-147.13,10.09c-3.58,0.95-7.14,1.96-10.69,3.01 C140,70.58,123,77.58,106.31,85.3C102.99,86.86,99.68,88.45,96.39,90.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1440,17.52c-61.53-9.16-129.54-7.57-213.74,9.27c-45.33,9.46-89.07,20.52-131.37,32.18 c-66.94,18.46-130.17,35.89-198.63,43.71c-37.95,3.93-72.73,3.43-106.34-1.5l-0.58,3.96c18.89,2.78,38.14,4.16,58.1,4.16 c15.91,0,32.27-0.88,49.26-2.64c68.8-7.86,132.17-25.33,199.27-43.83c42.24-11.65,85.92-22.69,131.11-32.12 c83.98-16.8,151.72-18.34,212.93-9.15V17.52z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shading"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.31,
    y: 34.52,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 274.6414 411.2931)",
    className: "st1",
    width: 52.68,
    height: 42.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.37,
    y: 57.89,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 359.6719 520.4517)",
    className: "st1",
    width: 94.66,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.54,
    y: 24.19,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 324.2643 474.1442)",
    className: "st1",
    width: 82.4,
    height: 72.04
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 730.84,
    y: 77.04,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 593.3768 844.0119)",
    className: "st1",
    width: 52.37,
    height: 42.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 681.59,
    y: 89.06,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 570.6849 812.9772)",
    className: "st1",
    width: 94.33,
    height: 12.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 641.54,
    y: 53.75,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 535.2717 763.4426)",
    className: "st1",
    width: 84.98,
    height: 72.04
  })), /*#__PURE__*/React.createElement("rect", {
    x: 609.98,
    y: 58.68,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 7.9297 -54.3981)",
    className: "st5",
    width: 40.06,
    height: 10.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 785.63,
    y: 84.61,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 626.2234 888.1845)",
    className: "st5",
    width: 23.83,
    height: 35.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.63,
    y: 84.39,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 502.3097 788.7686)",
    className: "st5",
    width: 23.47,
    height: 72.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.38,
    y: 127.24,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 13.9722 -58.5968)",
    className: "st6",
    width: 73.94,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.37,
    y: 89.61,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 579.8517 854.4038)",
    className: "st5",
    width: 27.13,
    height: 42.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.39,
    y: 117.87,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 13.3294 -64.9083)",
    className: "st6",
    width: 40.55,
    height: 6.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.46,
    y: 106.56,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 12.5108 -68.6861)",
    className: "st6",
    width: 40.55,
    height: 6.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.28,
    y: 122.54,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 534.6721 840.6474)",
    className: "st5",
    width: 27.13,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.64,
    y: 138.12,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 14.9744 -62.2833)",
    className: "st6",
    width: 13.27,
    height: 6.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.8,
    y: 106.75,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 12.0834 -53.8539)",
    className: "st5",
    width: 40.06,
    height: 10.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.58,
    y: 112.03,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 12.4479 -53.93)",
    className: "st6",
    width: 40.6,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.21,
    y: 82.77,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 10.0852 -58.0685)",
    className: "st6",
    width: 50.24,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.55,
    y: 63.69,
    transform: "matrix(0.9962 0.0867 -0.0867 0.9962 8.2638 -54.3016)",
    className: "st6",
    width: 39.03,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.09,
    y: 35.19,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 240.2508 368.3071)",
    className: "st5",
    width: 23.83,
    height: 35.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.45,
    y: 53.54,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 292.6865 498.4081)",
    className: "st5",
    width: 23.47,
    height: 72.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.31,
    y: 96.22,
    transform: "matrix(-0.9962 -0.0867 0.0867 -0.9962 822.2806 236.7031)",
    className: "st6",
    width: 73.94,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.98,
    y: 47.25,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 260.9475 421.8152)",
    className: "st5",
    width: 27.13,
    height: 42.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.77,
    y: 75.76,
    transform: "matrix(-0.9962 -0.0867 0.0867 -0.9962 713.8911 188.6786)",
    className: "st6",
    width: 40.55,
    height: 6.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.3,
    y: 57.18,
    transform: "matrix(-0.9962 -0.0867 0.0867 -0.9962 634.7247 148.0763)",
    className: "st6",
    width: 40.55,
    height: 6.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.21,
    y: 91.53,
    transform: "matrix(0.0867 -0.9962 0.9962 0.0867 323.4877 548.255)",
    className: "st5",
    width: 27.13,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.52,
    y: 107.19,
    transform: "matrix(-0.9962 -0.0867 0.0867 -0.9962 909.0115 260.0162)",
    className: "st6",
    width: 13.27,
    height: 6.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lineart"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M765.2,81.04c-2.09-0.18-3.92,1.36-4.11,3.45l-2.55,29.28c-0.18,2.09,1.36,3.92,3.45,4.11 c0.11,0.01,0.22,0.01,0.33,0.01c1.95,0,3.6-1.49,3.77-3.46l2.55-29.28C768.83,83.06,767.28,81.22,765.2,81.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752.45,79.93c-2.09-0.18-3.92,1.36-4.11,3.45l-2.55,29.28c-0.18,2.09,1.36,3.92,3.45,4.11 c0.11,0.01,0.22,0.01,0.33,0.01c1.95,0,3.6-1.49,3.77-3.46l2.55-29.28C756.08,81.95,754.53,80.11,752.45,79.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.32,87.71l-24.96-2.17l0.58-6.67c0.41-4.69-3.07-8.83-7.76-9.24l-34-2.96l1.03-11.81 c0.25-2.89-0.64-5.72-2.52-7.95s-4.5-3.6-7.4-3.85c-4.72-0.41-8.99,2.26-10.85,6.34c-0.51-0.14-1.03-0.24-1.57-0.29l-72.72-6.33 l-1.04,11.99l-31.16-2.71c-2.77-0.25-5.47,0.61-7.61,2.41c-2.14,1.79-3.45,4.31-3.69,7.08c-0.24,2.77,0.61,5.47,2.41,7.61 c1.79,2.14,4.31,3.45,7.07,3.69l31.16,2.71l-2.38,27.39l-31.16-2.71c-5.73-0.51-10.79,3.75-11.29,9.48 c-0.5,5.73,3.76,10.79,9.48,11.29l31.17,2.71l-1.01,11.62l72.72,6.33c0.25,0.02,0.51,0.03,0.76,0.03c0.28,0,0.56-0.02,0.84-0.04 c1.13,4.34,4.88,7.71,9.59,8.12c0.32,0.03,0.64,0.04,0.96,0.04c2.55,0,5.01-0.89,6.99-2.56c2.23-1.88,3.6-4.5,3.85-7.4l1.03-11.8 l34,2.96c0.25,0.02,0.5,0.03,0.75,0.03c4.37,0,8.11-3.36,8.49-7.79l0.56-6.42L805.6,119c0.46,0.04,0.92,0.06,1.37,0.06 c8.05,0,14.92-6.18,15.63-14.34C823.36,96.09,816.95,88.46,808.32,87.71z M614.8,65.28c-0.75-0.07-1.43-0.42-1.93-1.01 c-0.49-0.58-0.73-1.32-0.66-2.07c0.07-0.75,0.42-1.43,1.01-1.93c0.58-0.49,1.32-0.72,2.07-0.66l31.16,2.71L645.96,68L614.8,65.28z  M610.6,113.45c-1.56-0.14-2.72-1.52-2.59-3.08c0.14-1.56,1.53-2.72,3.08-2.59l31.16,2.71l-0.49,5.67L610.6,113.45z M713.48,134.11 l-65.16-5.67l2.57-29.56l50.05,4.36l1.64-18.89l-50.05-4.36L655.06,51l65.16,5.67c0.32,0.03,0.53,0.2,0.64,0.33 c0.12,0.14,0.25,0.37,0.22,0.69l-3.29,37.78l-3.29,37.78c-0.03,0.32-0.2,0.53-0.33,0.64C714.03,134,713.8,134.13,713.48,134.11z  M651.87,87.54l42.5,3.7l-0.33,3.78l-42.5-3.7L651.87,87.54z M728.26,139.2c-0.08,0.87-0.49,1.67-1.18,2.25 c-0.68,0.57-1.53,0.84-2.42,0.77c-1.82-0.16-3.18-1.77-3.02-3.59l0.41-4.72c0,0,0,0,0,0l3.29-37.78l3.7-42.5 c0.16-1.82,1.76-3.17,3.59-3.02c0.87,0.08,1.67,0.49,2.25,1.18c0.57,0.68,0.85,1.54,0.77,2.42l-4.01,46.06l-2.36,27.14h0 L728.26,139.2z M772.52,122.59c-0.04,0.52-0.51,0.91-1.03,0.86l-34-2.96l2.01-23.14l2.01-23.14l34,2.96 c0.52,0.05,0.91,0.51,0.86,1.03L772.52,122.59z M815.05,104.06c-0.19,2.15-1.21,4.1-2.88,5.5c-1.67,1.4-3.77,2.08-5.92,1.88 l-24.96-2.17l1.41-16.18l24.96,2.17C812.13,95.66,815.44,99.6,815.05,104.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.23,12.05c-2.9-0.25-5.72,0.64-7.95,2.52c-1.22,1.03-2.17,2.28-2.84,3.68l-65.85-5.73 c-4.68-0.42-8.83,3.07-9.24,7.76l-0.62,7.08l-34-2.96c-4.68-0.41-8.83,3.07-9.24,7.76l-0.58,6.67l-24.96-2.17 c-4.17-0.37-8.23,0.93-11.45,3.63c-3.22,2.7-5.19,6.49-5.56,10.65c-0.75,8.63,5.66,16.26,14.28,17.01l24.96,2.17l-0.56,6.42 c-0.2,2.27,0.5,4.48,1.97,6.23s3.52,2.81,5.79,3.01l34,2.96l-0.62,7.08c-0.2,2.27,0.5,4.48,1.97,6.23 c1.47,1.75,3.52,2.82,5.79,3.01l65.85,5.73c0.41,1.49,1.13,2.89,2.16,4.11c1.88,2.23,4.5,3.6,7.4,3.85 c0.32,0.03,0.64,0.04,0.96,0.04c2.55,0,5.01-0.89,6.99-2.56c2.23-1.88,3.6-4.5,3.85-7.4l7.4-85c0.25-2.89-0.64-5.72-2.52-7.95 S471.12,12.3,468.23,12.05z M310.89,60.39c-4.46-0.39-7.78-4.33-7.39-8.8c0.19-2.15,1.21-4.1,2.88-5.5s3.77-2.07,5.92-1.88 l24.96,2.17l-1.41,16.18L310.89,60.39z M342.4,77.89c-0.12-0.14-0.25-0.37-0.22-0.69l3.86-44.39c0.04-0.49,0.46-0.87,0.94-0.87 c0.03,0,0.06,0,0.08,0l34,2.96l-4.03,46.28l-34-2.96C342.72,78.19,342.52,78.03,342.4,77.89z M383.55,97.17 c-0.12-0.14-0.25-0.37-0.22-0.69l0.62-7.08h0l5.34-61.38h0l0.62-7.08c0.04-0.49,0.46-0.87,0.94-0.87c0.03,0,0.06,0,0.08,0 l65.16,5.67l-6.74,77.44l-65.16-5.67C383.87,97.48,383.66,97.31,383.55,97.17z M463.19,108.19c-0.08,0.88-0.49,1.67-1.18,2.25 c-0.68,0.57-1.54,0.84-2.42,0.77h0c-0.88-0.08-1.67-0.49-2.25-1.18c-0.57-0.68-0.85-1.54-0.77-2.41l7.4-85 c0.08-0.87,0.49-1.67,1.18-2.24c0.61-0.51,1.35-0.78,2.13-0.78c0.1,0,0.19,0,0.29,0.01c0.88,0.08,1.67,0.49,2.25,1.18 c0.57,0.68,0.85,1.54,0.77,2.42L463.19,108.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.58,37.53c-2.08-0.18-3.92,1.36-4.11,3.45l-2.55,29.28c-0.18,2.09,1.36,3.92,3.45,4.11 c0.11,0.01,0.22,0.01,0.33,0.01c1.95,0,3.6-1.49,3.77-3.46l2.55-29.28C360.21,39.55,358.67,37.71,356.58,37.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.33,38.64c-2.08-0.18-3.92,1.36-4.11,3.45l-2.55,29.28c-0.18,2.09,1.36,3.92,3.45,4.11 c0.11,0.01,0.22,0.01,0.33,0.01c1.95,0,3.6-1.49,3.77-3.46l2.55-29.28C372.96,40.66,371.42,38.82,369.33,38.64z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtriasError);
export default __webpack_public_path__ + "static/media/atrias-error.31a9966a7ab07b318a809556da17b1d6.svg";
export { ForwardRef as ReactComponent };